module.exports = __webpack_public_path__ + "img/3. New listings-en.047424b.png";